import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent {
  @Input() modalRef: NgbModalRef | undefined;
  @Input() title: string = 'Confirm Action';
  @Input() message: string = 'Are you sure you want to proceed?';
  @Input() confirmButtonText: string = 'Yes';
  @Input() cancelButtonText: string = 'No';
  @Input() confirmButtonClass: string = 'btn-danger';
  // Optional third action, closing with 'tertiary'. Left unset the modal stays
  // a plain two-button confirm that closes with true/false.
  @Input() tertiaryButtonText: string | undefined;
  @Input() tertiaryButtonClass: string = 'btn-outline-secondary';

  onConfirm(): void {
    if (this.modalRef) {
      this.modalRef.close(true);
    }
  }

  onTertiary(): void {
    if (this.modalRef) {
      this.modalRef.close('tertiary');
    }
  }

  onCancel(): void {
    if (this.modalRef) {
      this.modalRef.close(false);
    }
  }
}
